/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_SummaryInputs */

const en_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Rotation for Maximum Force Transfer`)
};

const es_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotación natural para máxima transferencia de fuerza`)
};

const de_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natürliche Rotation für maximale Kraftübertragung`)
};

const zh_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自然转动，实现最大发力传递`)
};

const ar_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوران طبيعي لأقصى نقل للقوة`)
};

const fr_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotation naturelle pour un transfert de force maximal`)
};

const vi_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoay tự nhiên để truyền lực tối đa`)
};

const sw_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mzunguko wa Asili kwa Uhamishaji wa Nguvu wa Kiwango cha Juu`)
};

const th_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การหมุนตัวตามธรรมชาติเพื่อถ่ายทอดแรงได้มากที่สุด`)
};

const bs_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prirodna rotacija za maksimalni prenos sile`)
};

const ja_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大限の力を伝える自然な回転`)
};

const ko_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 힘 전달을 위한 자연스러운 회전`)
};

const pt_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotação natural para a máxima transferência de força`)
};

const it_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotazione naturale per il massimo trasferimento di forza`)
};

const sv_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturlig rotation för maximal kraftöverföring`)
};

const nl_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natuurlijke rotatie voor maximale krachtoverdracht`)
};

const da_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturlig rotation for maksimal kraftoverførsel`)
};

const nb_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturlig rotasjon for maksimal kraftoverføring`)
};

const fi_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luonnollinen rotaatio voiman tehokkaimpaan siirtoon`)
};

const pl_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturalna rotacja dla maksymalnego przeniesienia siły`)
};

const ru_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Естественное вращение для максимальной передачи силы`)
};

const tr_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksimum Kuvvet Aktarımı için Doğal Rotasyon`)
};

const hi_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम बल स्थानांतरण के लिए स्वाभाविक घूर्णन`)
};

const id_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotasi Alami untuk Transfer Gaya Maksimal`)
};

const ms_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putaran Semula Jadi untuk Pemindahan Daya Maksimum`)
};

const cs_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přirozená rotace pro maximální přenos síly`)
};

const el_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φυσική περιστροφή για μέγιστη μεταφορά δύναμης`)
};

const he_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סיבוב טבעי להעברת כוח מרבית`)
};

const af_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natuurlike rotasie vir maksimale kragoordrag`)
};

const hu_method_content_step_05_summary = /** @type {(inputs: Method_Content_Step_05_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Természetes forgás a maximális erőátvitelért`)
};

/**
* | output |
* | --- |
* | "Natural Rotation for Maximum Force Transfer" |
*
* @param {Method_Content_Step_05_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_summary = /** @type {((inputs?: Method_Content_Step_05_SummaryInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_SummaryInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_summary(inputs)
	if (locale === "de") return de_method_content_step_05_summary(inputs)
	if (locale === "zh") return zh_method_content_step_05_summary(inputs)
	if (locale === "ar") return ar_method_content_step_05_summary(inputs)
	if (locale === "fr") return fr_method_content_step_05_summary(inputs)
	if (locale === "vi") return vi_method_content_step_05_summary(inputs)
	if (locale === "sw") return sw_method_content_step_05_summary(inputs)
	if (locale === "th") return th_method_content_step_05_summary(inputs)
	if (locale === "bs") return bs_method_content_step_05_summary(inputs)
	if (locale === "ja") return ja_method_content_step_05_summary(inputs)
	if (locale === "ko") return ko_method_content_step_05_summary(inputs)
	if (locale === "pt") return pt_method_content_step_05_summary(inputs)
	if (locale === "it") return it_method_content_step_05_summary(inputs)
	if (locale === "sv") return sv_method_content_step_05_summary(inputs)
	if (locale === "nl") return nl_method_content_step_05_summary(inputs)
	if (locale === "da") return da_method_content_step_05_summary(inputs)
	if (locale === "nb") return nb_method_content_step_05_summary(inputs)
	if (locale === "fi") return fi_method_content_step_05_summary(inputs)
	if (locale === "pl") return pl_method_content_step_05_summary(inputs)
	if (locale === "ru") return ru_method_content_step_05_summary(inputs)
	if (locale === "tr") return tr_method_content_step_05_summary(inputs)
	if (locale === "hi") return hi_method_content_step_05_summary(inputs)
	if (locale === "id") return id_method_content_step_05_summary(inputs)
	if (locale === "ms") return ms_method_content_step_05_summary(inputs)
	if (locale === "cs") return cs_method_content_step_05_summary(inputs)
	if (locale === "el") return el_method_content_step_05_summary(inputs)
	if (locale === "he") return he_method_content_step_05_summary(inputs)
	if (locale === "af") return af_method_content_step_05_summary(inputs)
	if (locale === "hu") return hu_method_content_step_05_summary(inputs)
	return en_method_content_step_05_summary(inputs)
});